import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { ReservationsService } from '../../service';


@Component({
    templateUrl: './check-plate.component.html'
})
export class CheckPlateComponent {
    componentState = eComponentLoadingState.Initial;
    errorMessage: string;

    plate: string;
    reservations: IReservation[];

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public reservationsService: ReservationsService
    ) { }

    onSearchClicked(): void {
        //validate plate length
        if (!this.plate || this.plate.length < 5) {
            this.errorMessage = 'Numarul de inmatriculare trebuie sa contina minimum 5 caractere';
            this.componentState = eComponentLoadingState.Error;
            return;
        }

        //get component in loading state
        this.componentState = eComponentLoadingState.Loading;

        //fetch data from backend
        this.reservationsService.getReservationsOf(this.plate).subscribe((data: IReservation[]) => {
            this.reservations = data;
            this.componentState = eComponentLoadingState.Loaded;
        }, (err) => {
            this.componentState = eComponentLoadingState.Error;
            this.errorMessage = 'A aparut o eroare';
        });
    }
}

enum eComponentLoadingState {
    Initial = 1,
    Loading = 2,
    Loaded = 3,
    Error = 4
}

interface IReservation {
    parkingReservationId: string;
    title: string;
    plate: string;
    reservedFrom: Date;
    reservedTo: Date;
    date: Date;
}
